import { get, post, put, remove } from '../Services/http';
import { catchError } from './Error.action';
import { show as showNotification } from './Notification.action';
import { hideCustomizedMessage, updateCustomizedMessage } from '../Actions/CustomizedMessage.action';
import { translate } from '../Services/translation';
import { CART_LOAD_ERROR, CART_RECEIVE } from '../constants';
import { initSubmit, completeSubmit, submitError } from './Checkout.action';
import { googleAnalytics } from '../Services/googleAnalytics';

export const load = () => (dispatch, getState) => {
  dispatch(receive({ isComplete: false }));
  setPriceCalculationMessage(dispatch);

  return get('/api/cart')
    .then((response) => response.json())
    .then((cart) => {
      dispatch(receive(cart));
      if (cart.allCreateLineExist) {
        dispatch(hideCustomizedMessage());
      } else {
        dispatch(updateCustomizedMessage(translate('checkout.customizedmessage.createline.add')));
      }
    })
    .catch((ex) => {
      dispatch(catchError(ex, (error) => loadError(error)));
      dispatch(hideCustomizedMessage());
    });
};

export const loadError = (error) => ({
  type: CART_LOAD_ERROR,
  payload: {
    error,
  },
});

export const receive = (cart) => ({
  type: CART_RECEIVE,
  payload: cart,
});

export const toggle = () => (dispatch, getState) => {
  dispatch(show(!getState().cart.showInfo));
};

export const add = ({
  articleNumber,
  quantity = 1,
  nodeIdToShowNotification = null,
  notificationMessage = null,
  hash = '',
}) => {
  return (dispatch) => {
    if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
      return;
    }

    return post('/api/cart/add', {
      articleNumber,
      quantity: parseInt(quantity),
    })
      .then((response) => response.json())
      .then((cart) => {
        dispatch(receive(cart));
        nodeIdToShowNotification &&
          dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
      })
      .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
  };
};

export const reorder = ({
  orderId,
  nodeIdToShowNotification = null,
  notificationMessage = null,
  hash = '',
}) => {
  if (orderId) {
    return (dispatch) => {
      return post('/api/cart/reorder', { orderId })
        .then((response) => response.json())
        .then((cart) => {
          dispatch(receive(cart));
          nodeIdToShowNotification &&
            dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
    };
  }
};

export const update = (rowSystemId, quantity) => (dispatch) => {
  initSubmit(dispatch);
  dispatch(updateCustomizedMessage(translate('checkout.customizedmessage.createline.delete')));
  return put(`/api/cart/update`, { rowSystemId, quantity })
    .then((response) => response.json())
    .then((cart) => {
      setPriceCalculationMessage(dispatch);
      dispatch(receive(cart));
      dispatch(hideCustomizedMessage());
    })
    .catch((ex) => {
      dispatch(receive({ isComplete: true }));
      dispatch(hideCustomizedMessage());
      dispatch(catchError(ex, (error) => submitError(error)));
    })
    .finally(() => {
      completeSubmit(dispatch);
    });
};

const setPriceCalculationMessage = (dispatch) => {
  dispatch(updateCustomizedMessage(translate('checkout.customizedmessage.pricecalculation')));
};

export const deleteSpecification =
  (id, lineId, inventoryLotId, rowSystemId) => (dispatch) => {
    initSubmit(dispatch);
    dispatch(updateCustomizedMessage(translate('checkout.customizedmessage.specification.delete')));
    return remove(`/api/cart/deleteSpecification`, {
      id,
      lineId,
      inventoryLotId,
      rowSystemId,
    })
      .then((response) => response.json())
      .then((cart) => {
        setPriceCalculationMessage(dispatch);
        dispatch(receive(cart));
        dispatch(hideCustomizedMessage());
      })
      .catch((ex) => {
        dispatch(receive({ isComplete: true }));
        dispatch(hideCustomizedMessage());
        dispatch(catchError(ex, (error) => submitError(error)));
      })
      .finally(() => {
        completeSubmit(dispatch);
      });
  };